// Mock data for cleaning service website

export const siteSettings = {
  companyName: "Мандарин",
  phone: "+375 29 186-13-40",
  phone2: "+375 33 360-76-01",
  email: "info@mandarin-cleaning.by",
  messengers: {
    viber: "viber://chat?number=%2B375291861340",
    whatsapp: "https://wa.me/375291861340",
    telegram: "https://t.me/+375291861340"
  },
  seo: {
    home: {
      title: "Мандарин - Клининговая компания Минск | Качественная уборка квартир",
      description: "Профессиональная уборка квартир и домов в Минске от компании Мандарин. Поддерживающая и генеральная уборка от 80 руб. Гарантия качества. ☎ +375 29 186-13-40",
      keywords: "уборка квартир минск, клининг минск, генеральная уборка, уборка после ремонта, мандарин"
    }
  }
};

export const heroSection = {
  title: "Качественная уборка квартир в Минске!",
  subtitle: "Доверьте нам чистоту, чтобы посвятить время себе и близким. Мы гарантируем высочайшее качество уборки по самым приятным ценам! Звоните: +375 29 186-13-40 (Евгений) или +375 33 360-76-01 (Иван)",
  formTitle: "Давайте обсудим чистоту вашего дома! Оставьте телефон для быстрого звонка.",
  backgroundImage: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4"
};

export const services = [
  {
    id: "podderzhivayushhaya",
    title: "Поддерживающая уборка",
    price: "От 80 р.",
    priceFrom: 80,
    icon: "container",
    image: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce",
    slug: "podderzhivayushhaya-uborka",
    description: "Регулярная поддерживающая уборка для поддержания чистоты и порядка в вашем доме.",
    fullDescription: "Поддерживающая уборка — это регулярный клининг, который помогает поддерживать чистоту в доме без больших усилий. Наши специалисты приезжают в удобное для вас время и выполняют все необходимые работы.",
    includes: [
      "Сухая и влажная уборка всех помещений",
      "Уборка кухни (мытье плиты, раковины, столешниц)",
      "Уборка санузла (мытье сантехники, зеркал, пола)",
      "Вынос мусора",
      "Протирание пыли на всех поверхностях",
      "Мытье полов во всех комнатах"
    ],
    duration: "2-4 часа",
    frequency: "Еженедельно или по запросу"
  },
  {
    id: "generalnaya",
    title: "Генеральная уборка",
    price: "От 190 р.",
    priceFrom: 190,
    icon: "sparkles",
    image: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df",
    slug: "generalnaya-uborka",
    description: "Глубокая комплексная уборка всех помещений с максимальным вниманием к деталям.",
    fullDescription: "Генеральная уборка — это глубокая и тщательная уборка всех помещений с использованием профессиональной химии и оборудования. Мы удаляем даже самые сложные загрязнения.",
    includes: [
      "Все работы из поддерживающей уборки",
      "Мытье окон внутри",
      "Чистка плинтусов",
      "Протирка дверей и дверных проемов",
      "Чистка батарей и радиаторов",
      "Мытье люстр и светильников",
      "Уборка внутри шкафов (по запросу)",
      "Чистка мягкой мебели пылесосом"
    ],
    duration: "4-8 часов",
    frequency: "Раз в 3-6 месяцев"
  },
  {
    id: "posle-remonta",
    title: "Уборка после ремонта",
    price: "От 6 р. за м²",
    priceFrom: 6,
    priceType: "м²",
    icon: "wrench",
    image: "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f",
    slug: "uborka-posle-remonta",
    description: "Профессиональная уборка после ремонта с удалением строительной пыли и загрязнений.",
    fullDescription: "Уборка после ремонта — это специализированная услуга для удаления строительной пыли, следов краски, цемента и других загрязнений после ремонтных работ.",
    includes: [
      "Удаление строительной пыли со всех поверхностей",
      "Мытье окон и подоконников",
      "Чистка радиаторов и батарей",
      "Удаление следов краски, клея, цемента",
      "Мытье полов (в том числе после стяжки)",
      "Протирка дверей и дверных коробок",
      "Мытье сантехники",
      "Вынос строительного мусора"
    ],
    duration: "От 6 часов",
    frequency: "Разовая услуга"
  },
  {
    id: "kuhnya",
    title: "Уборка кухни",
    price: "От 250 р.",
    priceFrom: 250,
    icon: "utensils",
    image: "https://images.unsplash.com/photo-1484154218962-a197022b5858",
    slug: "uborka-kuhni",
    description: "Глубокая уборка кухни с мытьем бытовой техники и шкафчиков.",
    fullDescription: "Профессиональная уборка кухни включает глубокую очистку всех поверхностей, бытовой техники и труднодоступных мест.",
    includes: [
      "Мытье плиты и духовки",
      "Чистка вытяжки",
      "Мытье холодильника снаружи и внутри",
      "Мытье микроволновки",
      "Мытье фасадов шкафчиков",
      "Чистка раковины и смесителя",
      "Мытье фартука и столешниц",
      "Мытье пола"
    ],
    duration: "2-3 часа",
    frequency: "По запросу"
  },
  {
    id: "sanuzla",
    title: "Уборка санузла",
    price: "От 100 р.",
    priceFrom: 100,
    icon: "bath",
    image: "https://images.unsplash.com/photo-1695002817411-203c7f19dfa3",
    slug: "uborka-sanuzla",
    description: "Тщательная уборка ванной комнаты и туалета с дезинфекцией.",
    fullDescription: "Профессиональная уборка санузла с использованием специальных средств для удаления известкового налета, плесени и дезинфекции.",
    includes: [
      "Чистка и дезинфекция унитаза",
      "Мытье ванны/душевой кабины",
      "Чистка раковины и смесителей",
      "Удаление известкового налета",
      "Мытье зеркал",
      "Чистка плитки и швов",
      "Мытье пола",
      "Удаление плесени (при наличии)"
    ],
    duration: "1-2 часа",
    frequency: "По запросу"
  }
];

export const aboutFeatures = [
  {
    icon: "calendar",
    title: "5 лет на рынке",
    description: "Более 10.000 довольных клиентов."
  },
  {
    icon: "star",
    title: "Идеальный результат",
    description: "Не устроил результат? Приедем и переделаем."
  },
  {
    icon: "shield-check",
    title: "Безопасность",
    description: "Ваша уверенность — наш приоритет. Если что-то пойдет не так, мы все компенсируем."
  },
  {
    icon: "users",
    title: "Мастера",
    description: "Проходят 3 этапа отбора перед началом работы."
  },
  {
    icon: "calculator",
    title: "Прозрачные цены",
    description: "Гарантируем фиксированную цену. Никаких сюрпризов и доплат после заказа."
  },
  {
    icon: "credit-card",
    title: "Оплата",
    description: "Оплата — только после того, как вы примите работу."
  }
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4",
  "https://images.unsplash.com/photo-1484154218962-a197022b5858",
  "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg",
  "https://images.unsplash.com/photo-1695002817411-203c7f19dfa3",
  "https://images.unsplash.com/photo-1620626011761-996317b8d101",
  "https://images.pexels.com/photos/6934233/pexels-photo-6934233.jpeg",
  "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce",
  "https://images.unsplash.com/photo-1686178827149-6d55c72d81df",
  "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f",
  "https://images.pexels.com/photos/4112621/pexels-photo-4112621.jpeg"
];

export const additionalServices = {
  kitchen: [
    { icon: "oven", title: "Духовой шкаф", price: "30 р." },
    { icon: "microwave", title: "Микроволновка", price: "20 р." },
    { icon: "wind", title: "Вытяжка", price: "30 р." },
    { icon: "refrigerator", title: "Холодильник", price: "40 р." },
    { icon: "cabinet", title: "Шкафчики", price: "от 6 р." },
    { icon: "utensils", title: "Посуда", price: "30 р. час" },
    { icon: "grid-2x2", title: "Плитка", price: "40 р. до 15м²" },
    { icon: "square", title: "Потолок", price: "40 р. до 15м²" }
  ],
  bathroom: [
    { icon: "grid-2x2", title: "Плитка", price: "30 р. до 15м²" },
    { icon: "bug", title: "Удаление плесени", price: "от 20 р." },
    { icon: "droplet", title: "Удаление налета", price: "от 20 р." },
    { icon: "square", title: "Потолок", price: "20 р." }
  ],
  rooms: [
    { icon: "cabinet", title: "Шкафчики", price: "6 р." },
    { icon: "lightbulb", title: "Люстра", price: "от 20 р." },
    { icon: "panels", title: "Шторы", price: "от 5 р." },
    { icon: "iron", title: "Глажка", price: "30 р. час" },
    { icon: "blinds", title: "Жалюзи", price: "от 10 р." },
    { icon: "door-open", title: "Балкон", price: "от 15 р." },
    { icon: "cabinet", title: "Шкаф", price: "от 12 р. до 32 р." },
    { icon: "sparkles", title: "Обеспыливание", price: "от 20 р." },
    { icon: "bed", title: "Смена п/белья", price: "5 р." }
  ]
};

export const faqItems = [
  {
    question: "Нужно ли быть дома во время уборки?",
    answer: "Нет! Не обязательно. Вам нужно только встретить наших специалистов, указать тонкости (если они есть), и можете спокойно идти по своим делам. За час до окончания работы мы позвоним вам, что бы вы все осмотрели и приняли."
  },
  {
    question: "Как подготовить питомцев к нашему визиту?",
    answer: "Наши мастера спокойно работают рядом с животными — для нас это обычная практика. К тому же, мы используем гипоаллергенные средства без резких запахов, полностью безопасные для ваших питомцев."
  },
  {
    question: "Гарантия качества: что это значит для вас?",
    answer: "Оплата только после вашего одобрения. Проверяете результат — если что-то не идеально, мы сразу всё исправим на месте. Ваше удовлетворение — наш главный критерий."
  }
];

export const cleaningProducts = {
  title: "Чистота, которая безопасна для вас и эффективна для дома.",
  description: "Наша чистота — это профессионализм и безопасность в одном флаконе. Мы работаем только сертифицированной химией от мировых лидеров. Она мгновенно справляется с загрязнениями, оставаясь бережной к поверхностям и безопасной для здоровья.",
  image: "https://images.pexels.com/photos/5217888/pexels-photo-5217888.jpeg"
};

export const teamImages = [
  "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce",
  "https://images.unsplash.com/photo-1686178827149-6d55c72d81df",
  "https://images.unsplash.com/photo-1627905646269-7f034dcc5738"
];